module.exports = __webpack_public_path__ + "img/faqs_progress.30688134.jpg";